import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { AccountService } from "../account/account.service";

interface IUploadResponse {
  uploadOccur: boolean;
  existingCount: number;
  duplicates: number;
}
@Injectable()
export class PropertyService {
  constructor(private accountService: AccountService, private db: AngularFireDatabase) { }

  getProperties(communityId): any {
    return this.db.list(`/properties/${communityId}`).valueChanges() || false;
  }

  getCommunityProperties(communityId): Promise<any> {
    return new Promise(resolve => {
      this.db.list(`/properties/${communityId}`)
        .valueChanges()
        .subscribe(properties => {
          resolve(properties);
        });
    });
  }

  delete(communityId, propertyId): any {
    return this.db.object(`/properties/${communityId}/${propertyId}`).remove();
  }

  checkIfUnitsExist(propertyId: string): any {
    return this.db.list(`/units/${propertyId}`).valueChanges();
  }

  deactivate(communityId, property): any {
    property.isActive = false;

    this.db.list(`/properties/${communityId}`).update(property.id, property);
  }

  activate(communityId, property): any {
    property.isActive = true;
    this.db.list(`/properties/${communityId}`).update(property.id, property);
  }

  store(communityId, property, canSkipDuplicateCheck: boolean = false): Promise<boolean> {
    return new Promise(resolve => {

      property["createdAt"] = property["updatedAt"] = Date.now();
      property["operatorId"] = this.accountService.getUserId();
      const propertyRef = this.db.list(`/properties/${communityId}`);

      if (canSkipDuplicateCheck) {
        propertyRef.push(property).then(result => propertyRef.update(result.key, { id: result.key }));
        resolve(true);
      } else {
        this.getExistingProperties(communityId).then(existingProperties => {
          if (!existingProperties.includes(property.address)) {
            propertyRef.push(property).then(result => propertyRef.update(result.key, { id: result.key }));
            resolve(true);
          } else {
            resolve(false);
          }
        });
      }
    });
  }

  update(communityId, propertyId, data): Promise<boolean> {

    return new Promise(resolve => {
      const existingProperties = [];
      this.getCommunityProperties(communityId).then(
        properties => {
          data["operatorId"] = this.accountService.getUserId();

          for (const item of properties) {
            existingProperties.push(item.address);
          }
          if (!existingProperties.includes(data.address)) {
            this.db.list(`/properties/${communityId}`).update(propertyId, data);
            resolve(true);
          } else {
            const property = properties.filter(item => item.id === propertyId);
            if (property.length && (property[0].name !== data.name || property[0].type !== data.type)) {
              this.db.list(`/properties/${communityId}`).update(propertyId, data);
              resolve(true);
            } else {
              resolve(false);
            }
          }
        }
      );
    });
  }

  async loadPropertyById(communityId, propertyId): Promise<any> {
    return this.db.object(`/properties/${communityId}/${propertyId}`).valueChanges().toPromise();
  }

  getPropertyById(communityId, propertyId): Observable<{}> {
    return this.db.object(`/properties/${communityId}/${propertyId}`).valueChanges();
  }

  import(data, communityId, operatorId): Promise<IUploadResponse> {
    return new Promise<IUploadResponse>(resolve => {
      const keys = data.shift();
      let properties = [];
      const filttered = {};

      for (const item of data) {
        const property = {};
        keys.forEach((key, index) => {
          property[key] = item[index] ? item[index].trim() : "";
          property["isActive"] = true;
          property["operatorId"] = operatorId;
        });
        properties.push(property);
        properties = properties.filter(
          propertyObject => {
            if (propertyObject.name && propertyObject.type && propertyObject.address) {
              filttered[propertyObject.address] = propertyObject;

              return true;
            }
          }
        );
      }

      this.getExistingProperties(communityId).then(existingProperties => {
        let existingCount = 0;
        let isUploaded = false;

        for (const property of Object.values(filttered)) {
          if (!existingProperties.includes(property["address"])) {
            this.store(communityId, property, true);
            isUploaded = true;
          } else {
            ++existingCount;
          }
        }

        const duplicates = data.length - Object.keys(filttered).length;
        const response: IUploadResponse = {
          duplicates: duplicates,
          existingCount: existingCount,
          uploadOccur: isUploaded
        };

        resolve(response);
      });

    });
  }

  getExistingProperties(communityId): Promise<Array<string>> {

    return new Promise(resolve => {
      const existingProperties = [];

      this.getProperties(communityId).subscribe(
        items => {
          for (const item of items) {
            existingProperties.push(item.address);
          }
          resolve(existingProperties);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/property/property.service.ts